import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

const path_codigos_Vital = 'assets/json/codigosVital.json';
const path_id_municipios = 'assets/json/municipiosID.json';
const path_codigos_paises = 'assets/json/codigosPaises.json';
@Injectable({
    providedIn: 'root'
})
export class DataService {
    constructor(private http: HttpClient) { }

    getCodigosVital(): Observable<any> {
        return this.http.get(path_codigos_Vital);
    }

    getMunicipiosData(): Observable<any> {
        return this.http.get(path_id_municipios); 
    }

    getPaisesData(): Observable<any> {
        return this.http.get(path_codigos_paises); 
    }
}
